import type { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react'
import type { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import { classNames } from '../util/helpers'

export const FormFieldWithErrors = ({
  label,
  registerProps,
  button,
  error,
  ...fieldProps
}: {
  label: string | JSX.Element
  registerProps: UseFormRegisterReturn
  button?: ReactNode
  error?: FieldError
} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>) => (
  <div className="form-group flex flex-col gap-2">
    <div className="mb-1 flex flex-row justify-between">
      <label htmlFor="input" className="text-1xl text-gray-800">
        {label}
      </label>
      {button}
    </div>
    <input
      type="text"
      autoComplete="false"
      className={classNames(
        'block w-full rounded-md border bg-gray-50 p-2.5 text-sm text-gray-900',
        error
          ? 'border-orange-800 focus:border-orange-500 focus:ring-orange-600'
          : 'border-gray-300 focus:border-serblue-light focus:ring-serblue-light',
      )}
      {...fieldProps}
      {...registerProps}
    />
    {error && (
      <div className="text-xs text-orange-800 flex justify-end h-4">
        {error.message}
      </div>
    )}
    {!error && <span className="h-4" />}
  </div>
)
